<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Body 3/Bold'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126915&m=dev'
*/

defineOptions({
  name: 'TextTertiaryMedium',
})

withDefaults(defineProps<TextTertiaryMediumProps>(), {
  is: 'div',
})

interface TextTertiaryMediumProps {
  is?: 'div' | 'p' | 'span'
}
</script>

<template>
  <component
    :is="is"
    class="p-text-tertiary-medium"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="./TextTertiaryMedium.scss" />
